import React, { Component } from 'react'
import { PropTypes } from 'prop-types';
import PagesNav from './Component/PagesNav/PagesNav';
import TopHeader from './Component/TopHeader/TopHeader';

class Header extends Component {
  constructor(props){
    super(props);
  }
  render() {    
    return (
      <header id="header" role="banner" data-test="main-header">
        <TopHeader />
        <PagesNav  {...this.props}/>
      </header>
    )
  }
}
Header.propTypes = {
  userSessionLoading: PropTypes.bool,
  staticContext: PropTypes.any,
};
export default Header